module.exports = __webpack_public_path__ + "static/media/img3.8ea4a594.png";